// TODO: When IE11 support is killed, revert back to using shadow dom and css properties (example: WEBX-203)
igws-logo {
  .logo__text {
    position: absolute;
    top: 37px;
  }

  &[image='dfx-dark'],
  &[image='dfx-light'] {
    .logo__text {
      left: 95px;
    }
  }

  &[image='ig-bank-dfx-dark'],
  &[image='ig-bank-dfx-light'] {
    .logo__text {
      left: 169px;
    }
  }

  .logo {
    display: block;
    height: 37px;
    width: 44px;
    margin: 10px 0 9px;
    background-image: @logo;
    background-repeat: no-repeat;

    &.ig-bank-dark,
    &.ig-bank-light {
      width: 134px;
    }
    &.dfx-dark,
    &.dfx-light {
      width: 265px !important;
      background-position: 0 0, 85px 0;
    }
    &.ig-bank-dfx-dark,
    &.ig-bank-dfx-light {
      width: 335px !important;
      background-position: 0 0, 160px -3px;
    }

    &.ig-bank-dark {
      background-image: @logo-bank-dark!important;
    }
    &.ig-bank-light {
      background-image: @logo-bank-light!important;
    }
    &.dfx-dark {
      background-image: @logo, @logo-dfx-dark!important;
    }
    &.dfx-light {
      background-image: @logo, @logo-dfx-light!important;
    }
    &.ig-bank-dfx-dark {
      background-image: @logo-bank-dark, @logo-dfx-dark!important;
    }
    &.ig-bank-dfx-light {
      background-image: @logo-bank-light, @logo-dfx-light!important;
    }
    &.ig-prime {
      height: 37px;
      width: 187px!important;
      background-image: @logo-prime!important;
      background-size: contain;
      html:lang(zh-AU) &,
      html:lang(zh-CA) &,
      html:lang(zh-CN) &,
      html:lang(zh-TW) &,
      html:lang(zh-Hans-AU) &,
      html:lang(zh-Hant-AU) &,
      html:lang(zh-Hans) &,
      html:lang(zh-Hant) & {
        height: 43px;
        background-image: @logo-prime-zh!important;
      }
    }
    &.ig-new-red {
      background-image: @logo-new-red!important;
    }
    &.ig-new-white {
      background-image: @logo-new-white!important;
    }

    span {
      text-indent: -9999px;
      overflow: hidden;
      display: block;
    }
  }

  &.logo--large {
    &[image='ig-bank-dfx-dark'],
    &[image='ig-bank-dfx-light'] {
      .logo__text {
        left: 195px;
      }
    }
    .logo {
      height: 75px;
      width: 75px;

      &.ig-bank-dark,
      &.ig-bank-light {
        width: 180px;
      }
      &.ig-bank-dfx-dark,
      &.ig-bank-dfx-light {
        width: 365px !important;
        background-position: 0 0, 185px -3px;
      }
    }
  }
}

// This is to support pages that are not dynamic
html:lang(de-CH),
html:lang(fr-CH),
html:lang(en-CH),
html:lang(it-CH) {
  igws-logo .logo {
    width: 134px;
  }
}

html:lang(de-CH),
html:lang(fr-CH),
html:lang(en-CH),
html:lang(it-CH) {
  igws-logo .logo {
    background-image: @logo-bank-dark;
  }

  .application-form,
  .navigation-header-logo.theme--dark {
    igws-logo .logo {
      background-image: @logo-bank-light;
    }
  }
}

// Only apply this changes to tablet and desktop views for campaign pages
@media only screen and (min-width: @small-breakpoint) {
  .campaign-page igws-logo.logo--large {
    .logo {
      height: 106px;
      width: 100px;

      &.ig-bank-dark,
      &.ig-bank-light {
        width: 255px !important;
      }
      &.dfx-dark,
      &.dfx-light {
        width: 370px !important;
        background-position: 0 0, 115px 0;
      }
      &.ig-bank-dfx-dark,
      &.ig-bank-dfx-light {
        width: 505px !important;
        background-position: 0 0, 250px -3px;
      }
    }
  }
}

// White labels logos
.header-cfd-trader,
.header-guardian-cfd,
.header-goodbody,
.header-fortuneo-derivatives,
.header-hargreaves-lansdown-cfd,
.header-hargreaves-lansdown-spreadBetting,
.header-tradebox-cfd,
.header-prt-cfd,
.header-sharenet-cfd,
.header-commsec {
  igws-logo .logo {
    height: 80px;
    background-position: center;
  }
}


igws-logo .logo {
  .header-cfd-trader & {
    background-image: @logo-cfd-trader;
    width: 90px;
  }
  .header-guardian-cfd & {
    background-image: @logo-gus-cfd;
    width: 194px;
  }
  .header-goodbody & {
    background-image: @logo-gby;
    width: 125px;
  }
  .header-fortuneo-derivatives & {
    background-image: @logo-fdf;
    width: 240px;
  }
  .header-hargreaves-lansdown-spreadBetting &,
  .header-hargreaves-lansdown-cfd & {
    background-image: @logo-hls-hlc;
    width: 170px;
  }
  .header-tradebox-cfd & {
    background-image: @logo-bdi;
    width: 220px;
  }
  .header-prt-cfd & {
    background-image: @logo-prt;
    width: 260px;
  }
  .header-sharenet-cfd & {
    background-image: @logo-sha;
    width: 340px;
  }
  .header-commsec & {
    background-image: @logo-csc;
    width: 232px
  }
}

@media only screen and (max-width: @medium-breakpoint) {
  igws-logo {
    flex: 1 1 auto;

    .logo__text {
      top: 15px;
    }

    &[image='dfx-dark'],
    &[image='dfx-light'] {
      .logo__text {
        left: 70px;
      }
    }

    &[image='ig-bank-dark'],
    &[image='ig-bank-light'] {
      .logo__text {
        left: 62px;
      }
    }

    &[image='ig-bank-dfx-dark'],
    &[image='ig-bank-dfx-light'] {
      .logo__text {
        left: 125px;
      }
    }

    .logo {
      height: 37px;
      width: 44px;

      &.ig-bank-dark,
      &.ig-bank-light {
        width: 99px !important;
      }
      &.dfx-dark,
      &.dfx-light {
        width: 175px !important;
        background-position: 0 0, 60px 0;
      }
      &.ig-bank-dfx-dark,
      &.ig-bank-dfx-light {
        width: 235px !important;
        background-position: 0 0, 115px -2px;
      }
      &.ig-prime {
        height: 20px;
        width: 102px !important;

        html:lang(zh-AU) &,
        html:lang(zh-CA) &,
        html:lang(zh-CN) &,
        html:lang(zh-TW) &,
        html:lang(zh-Hans-AU) &,
        html:lang(zh-Hant-AU) &,
        html:lang(zh-Hans) &,
        html:lang(zh-Hant) & {
          height: 24px;
          margin-left: -2px;
        }
      }
    }

    &.logo--large {

      &[image='ig-bank-dfx-dark'],
      &[image='ig-bank-dfx-light'] {
        .logo__text {
          left: 135px;
        }
      }
      .logo {
        height: 50px;
        width: 50px;

        &.ig-bank-dark,
        &.ig-bank-light {
          width: 120px !important;
        }
        &.ig-bank-dfx-dark,
        &.ig-bank-dfx-light {
          width: 245px !important;
          background-position: 0 0, 125px -3px;
        }
      }
    }
  }

  // This is to support pages that are not dynamic
  html:lang(de-CH),
  html:lang(fr-CH),
  html:lang(en-CH),
  html:lang(it-CH) {
    igws-logo .logo {
      width: 99px;
    }
  }
}

// LEAVE comments, we may nee to adapt the logic below in case IE fails

//@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
//  .dfx-dark.header__logo, .dfx-light.header__logo {
//    background-position: -94px 0, 39px 0;
//  }
//
//  .ig-bank-dfx-dark.header__logo, &.ig-bank-dfx-light.header__logo {
//    background-position: -94px 0, 86px 0;
//  }
//}
//
//@media only screen and (max-width: 800px) and (-ms-high-contrast: none), (-ms-high-contrast: active) {
//  .header__logo.dfx-dark, .header__logo.dfx-light {
//    background-position: -62px 0, 29px 0;
//  }
//
//  .ig-bank-dfx-dark.header__logo, &.ig-bank-dfx-light.header__logo {
//    background-position: -62px 0, 57px 0;
//  }
//
//  .ig-bank-dark.header__logo, &.ig-bank-light.header__logo {
//    background-position: -25px 0;
//  }
//}
